// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"84cbd6b0","453":"ce3ccb63","551":"8ded9a35","649":"26a4a037"}[chunkId] + ".chunk.js";
};